// 一个完整的模块

// 1.状态变量
const state = {
  userinfo: '',
  token: '',
  dialog: {
    isshow: false,
    type: 1, // 1登录 2忘记密码 3注册 4未开放
  },
};

// 2.同步方法 修改state变量
const mutations = {
  SET_USER: (state, data = Object) => {
    state.userinfo = data;
  },
  SET_TOKEN: (state, data = '') => {
    state.token = data;
  },
  SET_DIALOG: (state, data) => {
    state.dialog = data;
  },
};

// 3.异步调用mutations内的修改state的方法
const actions = {
  changeUser({ commit }, data = Object) {
    commit('SET_USER', data);
  },
  changeToken({ commit }, data = Object) {
    commit('SET_TOKEN', data);
  },
  changeDialog({ commit }, data = Object) {
    commit('SET_DIALOG', data);
  },
};

// 4.变量暴露出去
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
